export class MortalityConditionLevelTwo {
    ID;
    ParentConditionID;
    ConditionName;
    constructor({id, parentConditionID, conditionName}) {
        this.ID = id;
        this.ParentConditionID = parentConditionID;
        this.ConditionName = conditionName;
    }
}